export const APP_NAME = '/trackpro'